// Loader component — replaces MUI Backdrop with plain overlay
import React from "react";
import "./loader.css";

const CollabKareLoader = () => {
  return (
    <div
      className="loader_section"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1300,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div className="main_loader">
        <div>
          <svg id="page-loader">
            <circle cx="75" cy="75" r="20" style={{ animation: 'loader1 4s linear infinite' }} />
            <circle cx="75" cy="75" r="35" style={{ animation: 'loader2 4s linear infinite' }} />
            <circle cx="75" cy="75" r="50" style={{ animation: 'loader3 4s linear infinite' }} />
            <circle cx="75" cy="75" r="65" style={{ animation: 'loader4 4s linear infinite', transition: 'stroke-dashoffset 0.3s ease-in-out' }} />
          </svg>
        </div>
        <div>
          <p className="loadingText">Loading</p>
        </div>
      </div>
    </div>
  );
};

export default CollabKareLoader;
